var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-tree",
      class: {
        "el-tree--highlight-current": _vm.highlightCurrent,
        "is-dragging": !!_vm.dragState.draggingNode,
        "is-drop-not-allow": !_vm.dragState.allowDrop,
        "is-drop-inner": _vm.dragState.dropType === "inner"
      },
      attrs: { role: "tree" }
    },
    [
      _vm.height
        ? _c("virtual-list", {
            style: { height: _vm.height + "px", "overflow-y": "auto" },
            attrs: {
              "data-key": _vm.getNodeKey,
              "data-sources": _vm.visibleList,
              "data-component": _vm.itemComponent,
              keeps: Math.ceil(_vm.height / 22) + _vm.extraLine,
              "extra-props": {
                renderAfterExpand: _vm.renderAfterExpand,
                showCheckbox: _vm.showCheckbox,
                renderContent: _vm.renderContent,
                onNodeExpand: _vm.handleNodeExpand
              }
            }
          })
        : _vm._l(_vm.root.childNodes, function(child) {
            return _c("el-tree-node", {
              key: _vm.getNodeKey(child),
              attrs: {
                node: child,
                props: _vm.props,
                "render-after-expand": _vm.renderAfterExpand,
                "show-checkbox": _vm.showCheckbox,
                "render-content": _vm.renderContent
              },
              on: { "node-expand": _vm.handleNodeExpand }
            })
          }),
      _vm._v(" "),
      _vm.isEmpty
        ? _c("div", { staticClass: "el-tree__empty-block" }, [
            _c("span", { staticClass: "el-tree__empty-text" }, [
              _vm._v(_vm._s(_vm.emptyText))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dragState.showDropIndicator,
            expression: "dragState.showDropIndicator"
          }
        ],
        ref: "dropIndicator",
        staticClass: "el-tree__drop-indicator"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-547575a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-547575a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/tree/src/tree.vue
// module id = null
// module chunks = 